import { onClick, onKeyDown, onFocus} from "../utils";

export default class SvgInfo extends window.HTMLElement {
	constructor () {
		super();
		this.close = this.close.bind(this);
		this.open = this.open.bind(this);
	}

	close () {
		this.querySelector('div p').classList.remove('open');
	}
	open () {
		this.querySelector('div p').classList.add('open');
	}

	connectedCallback() {
		const svgName = this.getAttribute("svg");

		if (!svgName) {
			return new Error('Missing required `svg` attribute')
		}

		const originalValue = this.getAttribute("message");

		var url = originalValue.match(/(((ftp|https?):\/\/)[\-\w@:%_\+.~#?,&\/\/=]+)|((mailto:)?[_.\w-]+@([\w][\w\-]+\.)+[a-zA-Z]{2,3})/g);

		const uiValue = originalValue.replace(url, `<a aria-label="Link to this page on public site" href=${url} target="_blank">${url}</a>`);

		this.innerHTML = `
			<style>
				* {
					font-size: 1em;
				}
				.holder {
					position: relative;
					border: 1px solid #ccc;
					border-radius: 50%;
					padding: 9px;
					width: 40px;
					height: 40px;
					display: flex;
					align-items: center;
				}
				.holder:hover .tooltip-message, 
				.holder:focus .tooltip-message {
					transition: opacity .5s ease-in-out 0s;
					opacity: 1;
					z-index: 4;
				}
				.holder .icon {
					width: 20px;
					height: 20px;
				}
				.holder:hover, .holder:focus{
					background: #f4f4f4;
				}
				.tooltip-message {
					opacity: 0;
					position: absolute;
					background: #fff;
					width: max-content;
					color: #444;
					margin: 0;
					background: #fff;
					border: 1px solid #ccc;
					border-radius: 3px;
					padding: .75em;
					left: -10%;
					top: calc(100% + 1.15em);
					transition: all 1s ease-in-out .2s;
					z-index: -1;
				}
				.tooltip-message:before {
					content: '';
					z-index: 2;
					transform: rotate(45deg) !important;
					background: #fff;
					border: 1px solid #ccc;
					border-right: none;
					border-bottom: none;
					width: 20px;
					height: 20px;
					position: absolute;
					top: -11px;
				}

				.tooltip-message a {
					color: #29abe2;
				}
				
				.open{
					transition: opacity .5s ease-in-out 0s;
					opacity: 1;
					z-index: 4;
				}

				@media only screen and (max-width: 600px) {
					.tooltip-message {
						width: auto;
					}
				}
			</style>
			
			<div class="holder" aria-label="public link button" tabindex="0">
				<svg class="icon" viewBox="0 0 2048 2048">
					<use xlink:href="/apps/webapps/next/global/blazer/icons/icons.svg#${svgName}"></use>
				</svg>
				${ uiValue ? `<p class="tooltip-message" aria-expanded="true">${uiValue}</p>` : ''}
			</div>
		`;

		onClick(document.querySelector('body'), this.close.bind(this));
		onFocus(this.querySelector('div p a'), this.open.bind(this));
		onKeyDown(this.querySelector('div p a'), this.close.bind(this));
	}
}


// WEBPACK FOOTER //
// ./src/js/components/linkedSvg.js